import React from 'react';

import { Text } from '@simplybusiness/mobius-core';

const SlashDivider = () => (
  <Text
    width={13}
    height={37}
    fontSize={31}
    margin={0}
  >
    /
  </Text>
);

export default SlashDivider;
